module.exports = "<form name=\"{{ formName }}\" ng-submit=\"submitForm()\" ng-transclude></form>\n"